export default "__VITE_ASSET__DvFBolsR__";